import { ElementInfo } from "../Models/ElementInfoModel";
import * as OBC from "@thatopen/components";
import * as OBCF from "@thatopen/components-front";
import { ModelInfo } from "../Models/ModelInfo";
export const Select = (ids: ElementInfo[], components: OBC.Components, highlighter: OBCF.Highlighter, modelIds: ModelInfo[]) => {
    const fragments = components!.get(OBC.FragmentsManager);
    highlighter?.clear();
    ids.forEach((id) => {
        const modelFragmentId = modelIds.find((m) => m.modelId === id.modelId);
        highlighter?.highlightByID("select", (fragments.modelIdToFragmentIdMap({
            [modelFragmentId?.fragmentId!]: new Set([id.expressId]),
        })), false, true);

    });
}